// Modal.js
import React, { useEffect, useRef, useState } from 'react';
import './Modal.css';
import { useNavigate } from 'react-router-dom';
import Authentication from '../Authentication/Authentication';
import RequestProperty from '../RequestProperty/RequestProperty';
import KnowYourProperty from '../KYP/KnowYourProperty';
import PropertiesService from '../../Services/PropertiesService';
import logo from "../../assets/Images/LOGOS/Docity_Logo.png";

const Modal = ({ isOpen, closeModal, isSignup, resetForm, setIsSignup, otpVerification, propertyRequestSwitch, ShowPrevousData, editKypId }) => {

    const fileInputRef = useRef(null);
    const [selectSROType, setSelectSROType] = useState('');
    const [selectedSROType, setSelectedSROTypeError] = useState('');
    const [dropDown, setDropDown] = useState(false);
    const [mandalList, setMandalList] = useState();
    const [userImage, setUserImage] = useState('');

    const [userDetails, setUserDetails] = useState();
    const [token, setToken] = useState('');

    const navigate = useNavigate();
    useEffect(() => {
        setToken(localStorage.getItem('token') || '');
        setUserDetails(JSON.parse(localStorage.getItem('userDetails')));
        console.log(isSignup, 'isSignup')
    }, [isSignup]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target.closest('.user-icon') === null) {
                setDropDown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (!isOpen) {
        return null;
    }
    const activeView = isSignup;
    console.log(activeView, 'activeView');
    const modalClassName = token === '' 
        ? (activeView === 'firstpage' ? 'compact-modal' : `auth-modal ${activeView === 'signup' ? 'signup-modal-wrapper' : ''}`)
        : 'form-modal';

    return (
        <div className="modal-overlay">

            <div className={modalClassName}>
                {token == '' ?
                    <div>
                        <Authentication isSignup={isSignup}
                            setIsSignup={setIsSignup} otpVerification={otpVerification} closeModal={closeModal} />
                    </div>
                    :
                    <div>
                        {
                            propertyRequestSwitch == 'Request Property' ?
                                <RequestProperty propertyRequestSwitch={propertyRequestSwitch} ShowPrevousData={ShowPrevousData} size='xl' closeModal={closeModal} />
                                :
                                <KnowYourProperty propertyRequestSwitch={propertyRequestSwitch} ShowPrevousData={ShowPrevousData} closeModal={closeModal} editKypId={editKypId} />
                        }
                    </div>
                }
            </div>

        </div>
    );
};

export default Modal;

